import { SafeHtml } from '@angular/platform-browser';

export enum ImageAssetType {
  S3 = 'S3',
  LOCAL = 'LOCAL',
  ICON = 'ICON',
  S3_FORM = 'S3_FORM'
}

export interface ImageAsset {
  type: ImageAssetType;
  name?: string;
  bucket?: string;
  size?: string;
  formPath?: string;
  key?: string;
}

export interface FileAsset {
  name: string;
  data: string | ArrayBuffer;
}

export interface InfoGroup {
  groupLabel?: string;
  groupDescription: SafeHtml;
  groupImage: ImageAsset;
}

export interface CardAction {
  label: string;
  key: string;
  data?: CardActionDataItem[];
}

export interface CardActionDataItem {
  key: string;
  value: string;
}

export class IconAsset implements ImageAsset {
  type: ImageAssetType;
  name: string;
  _size?: string;

  constructor(type: ImageAssetType, name: string, size?: string) {
    this.type = type;
    this.name = name;
    if (size) {
      this._size = size;
    }
  }

  getSrc(): string {
    return this.name;
  }

  get size() {
    return this._size || 'md-5r';
  }
}
